import { styled } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

export const StyledSvgIcon = styled(SvgIcon)(({ size }) => ({
  ...(size && {
    height: size,
    width: size
  })
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpIcon/styles.js